import React from 'react';

import Select from 'react-select';

import ocimfStatus from '@/data/ocimfStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectOCIMFStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={ocimfStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={ocimfStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectOCIMFStatus;
